import React, { useEffect, useState } from "react";
import { Clock, Save } from "lucide-react";
import { toast } from "sonner";
import ResourceAdmin from "../../components/admin/ResourceAdmin";
import { adminApi, splashApi, apiError } from "../../lib/api";

function SplashDuration() {
  const [seconds, setSeconds] = useState(3);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    splashApi.getSettings()
      .then((d) => setSeconds(Math.round((d.duration_ms || 3000) / 1000)))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const save = async () => {
    const s = Math.max(2, Math.min(10, Number(seconds) || 3));
    setSaving(true);
    try {
      await splashApi.setSettings(s * 1000);
      setSeconds(s);
      toast.success(`Duración del splash: ${s} segundos`);
    } catch (e) { toast.error(apiError(e)); }
    finally { setSaving(false); }
  };

  return (
    <div data-testid="splash-duration" className="mb-6 rounded-2xl bg-white ring-1 ring-black/5 p-5">
      <div className="flex items-center gap-2 text-sm font-extrabold text-[#0A1C30]"><Clock className="w-5 h-5 text-[#E9A400]" /> Duración de la introducción (splash)</div>
      <p className="text-xs text-[#6B7688] mt-0.5 mb-3">Cuánto tiempo se muestra el logo + frase al abrir la app. Rango permitido: 2 a 10 segundos.</p>
      <div className="flex items-center gap-3">
        <input
          data-testid="splash-duration-input"
          type="number" min={2} max={10} step={1}
          value={seconds}
          disabled={loading}
          onChange={(e) => setSeconds(e.target.value)}
          className="w-24 rounded-xl border border-black/15 px-3 py-2 text-sm font-bold text-[#0A1C30] focus:outline-none focus:border-[#E9A400]"
        />
        <span className="text-sm text-[#6B7688]">segundos</span>
        <button
          data-testid="splash-duration-save"
          onClick={save} disabled={saving || loading}
          className="ml-auto flex items-center gap-2 rounded-xl bg-[#0A1C30] text-white px-4 py-2 text-sm font-bold disabled:opacity-60"
        >
          <Save className="w-4 h-4" /> {saving ? "Guardando…" : "Guardar duración"}
        </button>
      </div>
    </div>
  );
}

export default function SplashAdmin() {
  return (
    <div data-testid="splash-admin">
      <SplashDuration />
      <ResourceAdmin
        title="Frases del Splash"
        subtitle="Frases motivacionales que aparecen bajo el logo al abrir la app. Se muestran de forma rotativa: en cada apertura se elige una al azar de las activas."
        resource={adminApi.splashPhrases()}
        defaults={{ texto: "", orden: 99, activo: true }}
        fields={[
          { name: "texto", label: "Frase", type: "text", placeholder: "Ej. Formamos líderes" },
          { name: "orden", label: "Orden", type: "number" },
          { name: "activo", label: "Activa (visible en el splash)", type: "switch" },
        ]}
        columns={[
          { name: "orden", label: "#", render: (i) => <span className="text-[#6B7688]">{i.orden}</span> },
          { name: "texto", label: "Frase", render: (i) => <span className="font-bold text-[#0A1C30]">“{i.texto}”</span> },
          { name: "activo", label: "Estado", render: (i) => <span className={`text-xs font-bold ${i.activo !== false ? "text-[#22A860]" : "text-[#9AA3B2]"}`}>{i.activo !== false ? "Activa" : "Oculta"}</span> },
        ]}
      />
    </div>
  );
}
